// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"752bdf33","497":"f7eac5f8","787":"2892fa31"}[chunkId] + ".chunk.js";
};